import type { FeatureFlag } from '@/types';
import {
    FEATURE_ADAPTIVE_ENGINE,
    FEATURE_LOGBOOK,
    FEATURE_PROGRESS_PAGE,
    FEATURE_STRAVA_INTEGRATION,
    FEATURE_TRIATHLON,
    FEATURE_WEEKLY_CHECKIN,
} from '@/types';

const ACCESS_LEVEL_FEATURE_KEYS = new Set<string>([
    FEATURE_ADAPTIVE_ENGINE,
    FEATURE_LOGBOOK,
    FEATURE_PROGRESS_PAGE,
    FEATURE_STRAVA_INTEGRATION,
    FEATURE_TRIATHLON,
    FEATURE_WEEKLY_CHECKIN,
]);

export function supportsFeatureAccessLevel(key: string): boolean {
    return ACCESS_LEVEL_FEATURE_KEYS.has(key);
}

export const DEFAULT_FEATURE_FLAGS: Record<string, FeatureFlag> = {
    [FEATURE_ADAPTIVE_ENGINE]: {
        key: FEATURE_ADAPTIVE_ENGINE,
        description: 'Adaptive Engine (Reality Brain): evaluates completed weeks and surfaces non-punitive plan adaptation nudges.',
        isProOnly: false,
        isEnabled: true,
        accessLevel: 'admin_only',
    },
    [FEATURE_TRIATHLON]: {
        key: FEATURE_TRIATHLON,
        description: 'Triathlon planning, onboarding, coached-athlete creation, and triathlon-specific settings.',
        isProOnly: false,
        isEnabled: true,
        accessLevel: 'admin_only',
    },
    [FEATURE_LOGBOOK]: {
        key: FEATURE_LOGBOOK,
        description: 'Logbook page visibility in navigation and direct access. Activity syncing remains controlled by the Strava integration flag.',
        isProOnly: false,
        isEnabled: true,
        accessLevel: 'admin_only',
    },
    [FEATURE_WEEKLY_CHECKIN]: {
        key: FEATURE_WEEKLY_CHECKIN,
        description: 'Sunday Check-In modal, web push reminders, and weekly adaptation logic.',
        isProOnly: false,
        isEnabled: true,
        accessLevel: 'enabled',
    },
    [FEATURE_STRAVA_INTEGRATION]: {
        key: FEATURE_STRAVA_INTEGRATION,
        description: 'Strava account connection, activity import, and automatic activity sync.',
        isProOnly: false,
        isEnabled: true,
        accessLevel: 'admin_only',
    },
    [FEATURE_PROGRESS_PAGE]: {
        key: FEATURE_PROGRESS_PAGE,
        description: 'Progress page visibility in navigation and direct access.',
        isProOnly: false,
        isEnabled: true,
        accessLevel: 'enabled',
    },
};

export function getFeatureFlagFallback(key: string): FeatureFlag | undefined {
    return DEFAULT_FEATURE_FLAGS[key];
}
